import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

interface DeliveryNoteLabelProps {
  children: ReactNode
  showNotFoundWarning: boolean
}

const DeliveryNoteLabel = ({ children, showNotFoundWarning }: DeliveryNoteLabelProps) => {
  const { t } = useTranslation()

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}>
      {showNotFoundWarning && (
        <Tooltip title={t('suppliers_router.new_ticket_modal.delivery_note_not_found')}>
          <ExclamationCircleOutlined
            className="delivery-note-not-found-icon"
            style={{ cursor: 'pointer' }}
          />
        </Tooltip>
      )}
      {children}
    </span>
  )
}

export { DeliveryNoteLabel }
